import { faChevronDown } from '@fortawesome/pro-regular-svg-icons'

import { useTranslation } from '@flecto/translations'

import { Icon } from '../../../Icon/Icon'
import styles from '../../styles.module.css'
import {
  type FilterField,
  type FilterOption,
  filterTypeConfig,
  type FilterValue,
  type HandleFilterChange,
} from './filterTypeConfig'
import { MultiSelectOption } from './MultiSelectOption'

type renderOptionType = {
  option: FilterOption
  checked?: boolean
}

export const createMultiSelectProps = (
  field: FilterField,
  selectedFilters: FilterValue[],
  handleFilterChange: HandleFilterChange
) => {
  const { t } = useTranslation('shared', { keyPrefix: 'filters' })
  const { type, options, label } = field
  const config = filterTypeConfig[type] || { options, label }

  const translatedOptions =
    config.options?.map((option) => ({
      ...option,
      label: t(option.label),
    })) || []

  return {
    classNames: {
      dropdown: styles.filterMultiSelectDropdown,
      option: styles.filterMultiSelectOption,
      input: styles.filterMultiSelectInput,
    },
    styles: {
      dropdown: {
        padding: '0.250rem 0',
      },
    },
    rightSection: <Icon icon={faChevronDown} size='sm' />,
    placeholder: field.placeholder ?? `${t('multiselect.placeholder')}`,
    checkIconPosition: field.checkIconPosition,
    nothingFoundMessage: `${t('multiselect.nothing_found_message')}`,
    comboboxProps: { withinPortal: false },
    searchable: field.searchable,
    data: translatedOptions,
    withCheckIcon: true,
    icon: config.icon,
    renderOption: ({ option, checked }: renderOptionType) => (
      <MultiSelectOption
        option={{
          badgeColor: option.badgeColor,
          badgeSize: option.badgeSize,
          label: option.label,
          value: option.value,
          checked: checked,
        }}
      />
    ),
    onChange: (value: string | string[]) =>
      handleFilterChange(field.key, value),
    value:
      (selectedFilters.find((f) => f.key === field.key)?.value as string[]) ||
      [],
  }
}
